import {Component, OnInit} from '@angular/core';
import {ExampleDatas} from '../../datas';

@Component({
  selector: 'app-example-tax',
  templateUrl: './example-tax.component.html',
  styleUrls: ['./example-tax.component.scss']
})
export class ExampleTaxComponent implements OnInit {

  exampleDatas = ExampleDatas;

  constructor() {
  }

  ngOnInit(): void {
  }

}
